import { PrismEditorBlockReason } from 'constants/forms';

export const PrismBlockMessage = {
  [PrismEditorBlockReason.SEEDED_SYSTEM_FORM]:
    "This is a system form maintained in code, so it can't be opened in the editor.",
  [PrismEditorBlockReason.SCRIBAN]:
    "This template contains Scriban logic ({{ … }}) that the editor can't keep, so it can't be opened.",
};
